import { createContext, useContext } from "react";

export const StatsContext = createContext({});
export const useStatsContext = () => {
    return useContext(StatsContext);
}